export enum ServiceCaseStatus {
  /// <summary>
  /// New incident
  /// </summary>
  New = "New",

  /// <summary>
  /// Open incident
  /// </summary>
  Open = "Open",

  /// <summary>
  /// Closed incident
  /// </summary>
  Closed = "Closed",

  /// <summary>
  /// Resolved incident
  /// </summary>
  Resolved = "Resolved",
   /// <summary>
   /// In progress incident
   /// </summary>
  InProgress = "In Progress",

  /// <summary>
  /// Awaiting information incident
  /// </summary>
  AwaitingInfo = "Awaiting Info"

}
